module.exports = {
    config: {
        heartbeatRefreshOn: {
            'reconnect': true,
            'resourceChanged.bo_costCenters': true,
        },
    },

    methods: {

        getResourceFilters(storage, resourceFilters, actionKey, fieldCode){
            resourceFilters = resourceFilters || {}

            const parentEntityForProperties = this.model.parentEntityForProperties = this.model.parentEntityForProperties || this.getResourceRegisterContent('parentEntityForProperties') || {}
            if(parentEntityForProperties.resourceID){
                resourceFilters.invoiceID = parentEntityForProperties.resourceID
            } else {
                resourceFilters.invoiceID = -1
            }

            return resourceFilters
        },


        onHeartbeat(message, heartbeatPrewarmedResourceHashes){
            const refreshers 	= this.config.heartbeatRefreshOn || {}
            const key 			= message.heartbeatKey
            const invoiceID 	= (this.model.parentEntityForProperties || {}).resourceID

            if(refreshers[key] && (
                key !== 'resourceChanged.bo_costCenters' ||
                message.data.invoiceID == invoiceID
            )){
                this.refresh(true, { refreshResourcesViaHeartbeatKey: key, heartbeatPrewarmedResourceHashes })
            }
        },
    },

    handlers: [
        {
            name: 'heartbeat.resourceChanged',
            handle: function(callerComponent, message, heartbeatPrewarmedResourceHashes){
                this.onHeartbeat(message, heartbeatPrewarmedResourceHashes)
            }
        },
        {
            name: 'heartbeat.reconnect',
            handle: function(callerComponent, message, heartbeatPrewarmedResourceHashes){
                this.onHeartbeat(message, heartbeatPrewarmedResourceHashes)
            }
        },
    ],
}